/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_News_Meta_TitleInputs */

const ja_playdata_news_meta_title = /** @type {(inputs: Playdata_News_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ニュース`)
};

const en_playdata_news_meta_title = /** @type {(inputs: Playdata_News_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Playdata_News_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_news_meta_title = /** @type {((inputs?: Playdata_News_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_News_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_news_meta_title(inputs)
	return en_playdata_news_meta_title(inputs)
});